import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

// initial state
const state = {
  webName: ''
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/index.js